/**
 * Criteo DataLayer - PC entrypoint
 */
import { pushCriteoEvent } from '@/common/utils/criteo'

// グローバルに公開して、Slimテンプレートから呼び出せるようにする
;(window as Record<string, unknown>).pushCriteoEvent = pushCriteoEvent
